// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3TFMC","header":"Messages_header__2O52h"};